/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.AuthorizationRecordResponseDto>
>;
export function request(
  params: API.basics.authorizationRecord.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/authorizationRecord/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
